import usePDPBasicEvents from 'data-hooks/useEvents/usePDPBasicEvents';

const PDPPageAnalytics = () => {
  // inject all basic events "once"
  usePDPBasicEvents();

  return null;
};

export default PDPPageAnalytics;
